import { SdaTargetTypes } from './enums/sda-target-types';
import { Extension } from './extension';
import { Service } from './service';

export class Sda {
	public id: string;
	public organizationId: string;
	public number: string;
	public targetType: SdaTargetTypes;
	public target: string;
	public extension: Extension;
	public service: Service;
}
